// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17aKx","productName":"Table_productName__FZp8q"};